import { TypedRootState } from '../types';

export const selectRemarks = (state: TypedRootState) => state.remarks;
